
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
    name: 'SearchPBLPanel',
    components: {},
    props: {
        handleSearch: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const plan = ref('');
        const block = ref('');
        const lot = ref('');
        const isSearching = ref<boolean>(false);

        const isClearable = computed(() => isSearching.value);

        const clearForm = () => {
            plan.value = '';
            block.value = '';
            lot.value = '';
            isSearching.value = false;
        };

        const onEnter = () => {
            if (!plan.value) {
                return;
            }
            isSearching.value = true;

            let query = `${plan.value}`;

            if (block.value) {
                query = `${query}-${block.value}`;
                if (lot.value) {
                    query = `${query}-${lot.value}`;
                }
            }

            clearForm();
            props.handleSearch(query);
        };

        return {
            plan,
            block,
            lot,
            isClearable,
            clearForm,
            onEnter
        };
    }
});
